import { Card, Icon} from '@metsooutotec/modes-react-components';
import React, { ReactNode } from 'react';
import { itemViewDetailsContainerStyles } from '../components/common-style/common-style';

const tableContainerStyles = {
    ...itemViewDetailsContainerStyles,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '91%',
};

const iconAndTextStyle = {
    display: 'flex', 
    alignItems: 'center', 
    gap: '0.5em',
};
interface ErrorBoundaryProps {
    children: ReactNode; // Define the children prop
    navigationPath: string | undefined
}

interface ErrorBoundaryState {
    hasError: boolean;
    error?: Error;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }    

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('ErrorBoundary caught an error', error, errorInfo);
    }

    componentWillReceiveProps(nextProps: Readonly<ErrorBoundaryProps>, nextContext: any): void {
        if(this.state.hasError && this.props.navigationPath != nextProps.navigationPath){
            this.setState({ hasError: false, error: undefined });
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={tableContainerStyles}>
                    <Card
                        collapsible
                        content={
                            <p>Error: {this.state.error?.toString()}</p>
                        }
                        header={
                            <span style={iconAndTextStyle}>
                                <Icon color="red" key="error-boundary" name="icon-alarm-24" />
                                <h4 style={{ display: 'contents' }}>Something went wrong!</h4>
                            </span>
                        }
                    />
                </div>
            );
           
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
